import type { JSX } from 'react'
import type { ICheckboxProps } from '../CheckBox'

import { Checkbox } from '../CheckBox'
import { Background } from '../CheckBox.h'

export interface ICheckBoxAccentMainGradient extends ICheckboxProps {
  id: string
  name: string
}

export const CheckBoxAccentMainGradient = ({
  id,
  name,
  backgroundChecked = Background.ACCENT_PRIMARY_GRADIENT,
  ...rest
}: ICheckBoxAccentMainGradient): JSX.Element => {
  return (
    <Checkbox
      id={id}
      name={name}
      backgroundChecked={backgroundChecked}
      {...rest}
    />
  )
}
